import React, { useEffect, useState } from "react";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLanguage } from "../tools/LanguageContext";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import MediaImage from "../tools/Media"

function FreeBets() {
  const { translations, language } = useLanguage();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [bets, setBets] = useState([]);

  // Φόρτωση των μηνυμάτων από το Free Telegram channel
  useEffect(() => {
    AOS.init({ duration: 1000 });

    const fetchBets = async () => {
      try {
        const response = await axios.get("https://artofbetting.gr/api/free-bets");
        setBets(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchBets();
  }, [navigate, translations.alertTokenExpired, language]);

  return (
    <div className="bg-gray-900 text-white min-h-screen p-4">
      <header className="flex justify-between items-center p-4 bg-gray-800 rounded-lg">
        <h1 className="text-3xl font-bold">ART OF BETTING</h1>
        <nav className="flex space-x-4">
          <Link to="/">
            <button className="bg-green-800 px-4 py-2 rounded hover:bg-green-900">
              {translations.home}
            </button>
          </Link>
        </nav>
      </header>

      <main className="mt-6">
        <div className="flex flex-col items-start">
          <h2 className="text-3xl font-bold mb-4">{translations.freeBetsToday}</h2>
          <a href="https://t.me/+nbK1DNkxP9pjNTc0" target="_blank" rel="noreferrer">
            <button className="px-4 py-2 mb-4 rounded bg-green-800">{translations.joinFreeChannel}</button>
          </a>
        </div>

        {loading ? (
          <div className="text-center bg-green-800 p-4 rounded-lg">
            <p>{translations.loading}</p>
          </div>
        ) : (
          <div className="bg-gray-800 p-4 rounded-lg shadow-lg">
            {bets.filter((bet) => bet.text || bet.media).map((bet, index) => (
                <div
                  key={index}
                  className="border-b border-gray-700 py-4"
                  data-aos="fade-up"
                  data-aos-offset="100"
                >
                  <p className="text-xl break-words" style={{ whiteSpace: 'pre-line' }}>{bet.text}</p>
                  {bet.media && (
                    <MediaImage media={'/free'+bet.media} />
                  )}
                </div>
              ))
            }
          </div>
        )}
      </main>

      <footer className="relative w-full bg-gray-900 py-8">
        <div className="flex flex-col items-center justify-between w-full">
          <p className="text-xl font-bold border-b border-t p-4 mb-8">© Copyright 2025 Art Of Betting</p>
          <p className="text-lg font-bold border-b border-t p-2 mb-8 text-center">
            <span className="font-semibold">Διαφημιστειτε εδώ:</span>{' '}
            <a href="mailto:artofbetting2025@gmail.com" className="hover:underline">
              artofbetting2025@gmail.com
            </a>
          </p>

          <div className="flex items-center justify-between w-2/5 mb-8">
            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-1/5 mr-8">
              <img
                src="images/21.svg"
                alt="21+"
                className="w-full h-auto"
              />
            </a>

            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-4/5">
              <img
                src="images/kethea.svg"
                alt="kethea"
                className="w-full h-auto"
              />
            </a>
          </div>

          <a href="https://certifications.gamingcommission.gov.gr/publicRecordsOnline/SitePages/AffiliatesOnline.aspx" target="_blank" rel="noopener noreferrer">
            <img
              src="images/eeep.png"
              alt="eeep"
              className="w-full h-auto border-b border-t p-4"
            />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default FreeBets;
